import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/global-notice'

const DEFAULT_SIZE = 10

const LIST_API = `${API_PREFIX}/list`

const RECEIVE_LIST = `NOTICE_RECEIVE_LIST`

export const CHANGE_PAGE = `NOTICE_CHANGE_PAGE`

export const SHOW_MODAL = `NOTICE_SHOW_MODAL`

export const HIDE_MODAL = `NOTICE_HIDE_MODAL`

export const CHANGE_SETTING = `NOTICE_CHANGE_SETTING`




//action
function getData(params,dispatch) {
    return http.get(`${LIST_API}?${qs.stringify(params)}`)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}

export function getList() {
    return (dispatch,getState) => {
        const {notice: {page}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        getData(data,dispatch)
    };
}

export function add(formData) {
    return (dispatch,getState) => {
        return http.post(`${API_PREFIX}/add`,formData)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        detail: false,
        id: null,
        content: null
    },
    notice: {
        title: '',
        content: ''
    }
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id,content}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id,content}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_SETTING]: (state,{value,key}) => {
        return {...state,notice: {...state.notice,[key]: value}}
    },
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/notice/reducers/list.js